import { css, SerializedStyles } from '@emotion/react';
import { Person } from '@weave/schema-gen-ts/dist/schemas/persons/v3/persons.pb';
import dayjs from 'dayjs';
import { Photos } from '@frontend/photos';
import { titleCase } from '@frontend/string';
import { theme } from '@frontend/theme';
import { Text, styles as dsStyles } from '@frontend/design-system';

const styles = {
  person: {
    info: css`
      display: flex;
      flex-flow: row;
      gap: ${theme.spacing(1)};
      align-items: center;
    `,
    name: css`
      width: 100%;
    `,
    details: css``,
    detailsContainer: css``,
  },
};

export const personFullName = (patient: Person) => `${patient?.firstName ?? ''} ${patient?.lastName ?? ''}`.trim();

export const PaymentsPersonSearchContent = ({ person, css: cssStyle }: { person: Person; css?: SerializedStyles }) => {
  return (
    <div css={[styles.person.info, cssStyle]}>
      <Photos.ContactProfilePhoto personId={person.personId} name={personFullName(person)} size='medium' disableClick />
      <div css={styles.person.detailsContainer}>
        <Text css={styles.person.name} textAlign='left'>
          {personFullName(person)}
        </Text>
        <PersonSecondaryInfo person={person} />
      </div>
    </div>
  );
};
const PersonSecondaryInfo = ({ person }: { person: Person }) => (
  <Text
    color='light'
    size='small'
    textAlign='left'
    css={[
      css`
        max-width: 100%;
      `,
      dsStyles.truncate,
    ]}
  >
    {getPersonV3SecondaryInfoString(person)}
  </Text>
);

const formatStatus = (status?: Person['status']): string => {
  if (!status) return '';
  const withSpaces = status.replace(/_/g, ' ');
  return titleCase(withSpaces);
};

const getPersonV3SecondaryInfoString = (person: Person) => {
  const personStatus = formatStatus(person.status);
  const stringElements: (string | number)[] = [];
  if (person.gender) stringElements.push(person.gender);
  if (person.birthdate) stringElements.push(dayjs(person.birthdate).diff(dayjs(), 'years') * -1);
  if (personStatus) stringElements.push(personStatus);
  return stringElements.join(' • ');
};
